import React, { Component } from "react";
import { Redirect } from 'react-router-dom';


import request from 'request';

export default class SSO extends Component {


    constructor(props) {
        super(props)
        this.state = {
            oauth: false
        }
    }

    componentDidMount() {
        if (this.props.location.search.split('=').length > 1) {
            let code, state;
            let queryStrings = this.props.location.search.split(/(&|\?)/g).filter((x) => x.includes('='));
            queryStrings.filter(x => x.includes('state')).map(x => {
                return state = x.split('=')[1];
            })
            queryStrings.filter(x => x.includes('code')).map(x => {
                return code = x.split('=')[1];
            })

            const payload = { state, code };
            const params = {
                FunctionName: 'github-auth',
                Payload: JSON.stringify(payload)
            }

            // const stageUrl = 'https://gcdd7zl4dc.execute-api.us-west-2.amazonaws.com/production/github';
            // const prodUrl = 'https://km33w46g56.execute-api.us-west-2.amazonaws.com/production/github';
            const stageUrl = 'https://n4zdiheyf1.execute-api.us-west-2.amazonaws.com/LATEST/access';
            const prodUrl = 'https://k70kv8yeh2.execute-api.us-west-2.amazonaws.com/LATEST/access';
            const apiUrl = (this.props.environment === 'production') ? prodUrl : stageUrl;

            request({
                method: 'GET',
                url: apiUrl,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "*",
                    code,
                    state
                },
            }, (err, response, body) => {
                if(err) {
                    console.log('ERROR:::')
                    console.log(err);
                    throw err; 
                }

                if(response) {
                    localStorage.setItem('db-oauth', body.replace(/"/g, '')) 
                    this.setState({oauth: true})
                }
            })
        }
    }


    render() {
        if (this.state.oauth) {
            return (
                <Redirect
                    to={{
                        pathname: "/",
                    }}
                />
            )
        } else {
            return (
                <div>
                    <p>Redirecting back to Defect Dashboard...</p>
                </div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/SSO.js